import { httpClient } from '../http/httpClient'

export interface ForgotPasswordResponse {
  success: boolean
}

export interface ForgotPasswordParams {
  cpf: string
}

export const forgotPassword = async (params: ForgotPasswordParams) => {
  const { data } = await httpClient.post<ForgotPasswordResponse>(
    '/auth/forgot-password',
    params,
  )
  return data
}
